'use client';

import React, { useState, useEffect } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import useHideOnSite from '../../hooks/useLanguageFilter';

const FormCheckbox = ({ blok, handleInputChange, formValue }) => {
  const [checked, setChecked] = useState(formValue);

  // This is for a controlled reset of the checkbox. If the formValue is reset (i.e. not "on"), the checkbox should be reset as well.
  useEffect(() => {
    if (!formValue) {
      setChecked(false);
    }
  }, [formValue]);

  return useHideOnSite(blok.hide_on_site) ? null : (
    <div
      className={`mb-2 mr-6 px-4 md:px-8 col-span-12 ${
        blok.row_width ? '' : 'md:col-span-3'
      } `}
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      <label className="flex items-left">
        <input
          type="checkbox"
          name={blok.name}
          id={blok.name}
          className="form-checkbox w-5 h-5 mr-2 rounded bg-yellow-25 transition ease-in-out 
              bg-transparent checked:bg-transparent focus:bg-transparent 
              color-black-50 focus:color-black-50 checked-black-50
              border border-solid border-black-50 
              focus:border-black-50 checked:border-black-50 
              focus:ring-black-30 checked:ring-black-30
              ring-offset-shadow-0
              checked:text-transparent "
          required={blok.required}
          onChange={(e) => {
            handleInputChange(e);
            setChecked(!checked);
          }}
          checked={checked}
        />
        <span className="text-sm font-normal">{blok.label}</span>
      </label>
    </div>
  );
};

export default FormCheckbox;
